import DOMPurify from 'dompurify';

export function convertIframes(text) {
  convert(text)
}

function convert(text) {
  // Get all <p> elements in the div
  const paragraphs = text.querySelectorAll('p');

  // Loop through each <p> element
  paragraphs.forEach((paragraph, i) => {
    // Get the HTML code inside the <p> element
    const html = paragraph.innerHTML;
    // Find all <iframe> tags in the HTML code
    const iframeRegex = /&lt;iframe.*?&lt;\/iframe&gt;/gi;
    const iframeMatches = html.match(iframeRegex);

    // Loop through each <iframe> tag
    if (iframeMatches) {
      iframeMatches.forEach((iframe, j) => {
        // Replace the <iframe> tag with a marker for later insertion
        const marker = `@@${i}-${j}@@`;
        const replacedHtml = html.replace(iframe, marker);

        // Set the new HTML code back into the <p> element
        paragraph.innerHTML = replacedHtml;

        // Create a new <div> element to parse the <iframe> tag
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = DOMPurify.sanitize(iframe);

        // Extract the src, width, and height attributes using regex
        const srcRegex = /src="([^"]*)"/i;
        const widthRegex = /width="([^"]*)"/i;
        const heightRegex = /height="([^"]*)"/i;

        const srcMatch = iframe.match(srcRegex);
        const widthMatch = iframe.match(widthRegex);
        const heightMatch = iframe.match(heightRegex);

        // Create a new <iframe> element with the extracted attributes
        const newIframe = document.createElement('iframe');
        newIframe.src = srcMatch[1];
        newIframe.width = "100%"
        newIframe.height = "100%";

        // Find the marker in the new HTML code and replace it with the <iframe> element
        const newHtml = paragraph.innerHTML.replace(marker, newIframe.outerHTML);

        // Set the final HTML code back into the <p> element
        paragraph.innerHTML = newHtml;
      });
    }
  });

  // Return the updated text
  return text.innerHTML;
}
